var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"jsoneditor-vue"}),(_vm.showBtns!==false)?_c('div',{staticClass:"jsoneditor-btns"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }